import React, { useContext, useState, useEffect } from "react";
import { ContextProfileUser } from "../../lib/profileContext";

import "./BirthdayForm.scss";

import ProgressDots from "../ProgressDots/ProgressDots";
import SelectGlobal from "../SelectGlobal";
import ButtonSubmit from "../ButtonSubmit";

import { errorEventsBirthday } from "../../constants";
import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  simplyClick,
  validateAge,
} from "../../helpers";

const BirthdayForm = ({ nextStep }) => {
  const [errorDate, setErrorDate] = useState({
    month: false,
    day: false,
    year: false,
    message: null,
  });
  const [birthdayData, setBirthdayData] = useState({});
  const { data, setData } = useContext(ContextProfileUser);

  useEffect(() => {
    const allFilled =
      birthdayData.month && birthdayData.day && birthdayData.year;

    if (allFilled) {
      setErrorDate({
        month: false,
        day: false,
        year: false,
        message: null,
      });
    }
  }, [birthdayData]);

  const handlerSubmit = (e) => {
    e.preventDefault();

    const hasMonth = Boolean(birthdayData.month);
    const hasDay = Boolean(birthdayData.day);
    const hasYear = Boolean(birthdayData.year);

    if (!hasDay && !hasMonth && !hasYear) {
      simplyClick("err_lnd_age_nodate");
      setErrorDate({
        month: true,
        day: true,
        year: true,
        message: "Please enter your date of birth",
      });
      return;
    }

    const dateKey = [
      hasMonth ? "M" : "",
      hasDay ? "D" : "",
      hasYear ? "Y" : "",
    ].join("");

    if (errorEventsBirthday[dateKey]) {
      simplyClick(errorEventsBirthday[dateKey]);
      setErrorDate({
        month: !hasMonth,
        day: !hasDay,
        year: !hasYear,
        message: "Please enter your date of birth",
      });
      return;
    }

    const { error, status, errors } = validateAge(
      birthdayData.month,
      birthdayData.day,
      birthdayData.year
    );

    if (!status) {
      setErrorDate({
        month: errors.month || errors.invalidDate,
        day: errors.day || errors.invalidDate,
        year: errors.year || errors.invalidDate,
        message: error,
      });
      return;
    }

    const formattedDate = getBirthdayInFormat(
      birthdayData.year,
      birthdayData.month,
      birthdayData.day
    );

    setData({
      ...data,
      birthday: formattedDate,
    });

    simplyClick("cl_lnd_age_st4_action", { text: "next" });

    nextStep();
  };

  const handleAddBirthdayField =
    (field) =>
    ({ target: { value } }) => {
      setBirthdayData((prev) => ({ ...prev, [field]: value }));
      setErrorDate((prev) => ({ ...prev, [field]: false }));

      simplyClick("cl_lnd_age_st4_choose_date", {
        text: `${field}_choose (${value})`,
      });
    };

  return (
    <div className="promo__wrapper-birthday">
      <div className="user__form-top">
        <h3>My date of birth</h3>
      </div>
      <form className="form__date" onSubmit={handlerSubmit}>
        <div className="dates_error">
          <div className="date__wrapper">
            <SelectGlobal
              dateArray={getMonths()}
              data={birthdayData.month}
              handleChange={handleAddBirthdayField("month")}
              label="Month"
              error={errorDate.month}
              useIndexAsValue={true}
            />
            <SelectGlobal
              dateArray={getDate()}
              data={birthdayData.day}
              handleChange={handleAddBirthdayField("day")}
              label="Day"
              error={errorDate.day}
            />

            <SelectGlobal
              dateArray={getYears()}
              data={birthdayData.year}
              handleChange={handleAddBirthdayField("year")}
              label="Year"
              error={errorDate.year}
            />
          </div>

          {errorDate.message && (
            <p className="errorDate">{errorDate.message}</p>
          )}
        </div>
        <div className={"birthday_confirm"}>
          By proceeding, you confirm you are at least 18 years old and fully legally capable of using our website. 
        </div>

        <ButtonSubmit
          className={"button__global button__birthday"}
          text={"NEXT"}
        />
        <ProgressDots total={12} activeCount={4} />
      </form>
    </div>
  );
};

export default BirthdayForm;
